export const SPEND_LIMIT_ALERT_PATH = 'Omnichannel Admin > Canais > Avançado > Alertas automáticos'

export const SPEND_LIMIT_ALERT_MAX_NOTIFICATION_USERS = 10

/**
 * Rota do CRM que abre o Omnichannel Admin (wp-admin) no iframe, com a sessão. É relativa como as demais URLs do
 * sininho e o clique abre em nova aba. O wp-admin abre na tela inicial: ir direto ao canal e ao menu depende de o
 * CRM repassar o destino ao iframe, o que hoje não existe.
 */
export const SPEND_LIMIT_ALERT_URL = '/portal/acessaSistema.do#/app.do%23%2Fadminwhatsappv2'

export type SpendLimitAlertThreshold = 50 | 90 | 100

export type SpendLimitAlertTextParams = {
    channelName: string
    threshold: SpendLimitAlertThreshold
    blockOnExceed: boolean
}

/** Texto gravado no documento no momento do disparo: mudar o bloqueio depois não altera o que já foi enviado. */
export const buildSpendLimitAlertText = ({
    channelName,
    threshold,
    blockOnExceed
}: SpendLimitAlertTextParams): string => {
    const prefix = `O canal de WhatsApp ${channelName} atingiu ${threshold}% do limite de mensagens livres do período.`
    const suffix = `Consulte em ${SPEND_LIMIT_ALERT_PATH}.`
    if (threshold < 100) return `${prefix} ${suffix}`
    return blockOnExceed
        ? `${prefix} O envio de novas mensagens livres foi bloqueado até o próximo ciclo. ${suffix}`
        : `${prefix} O envio continua normalmente. ${suffix}`
}
